module.exports = __webpack_public_path__ + "static/media/App_LogoLocki.ae68f2f8.svg";